import AppointmentFlowFooter from './AppointmentFlowFooter';

export default AppointmentFlowFooter;



// WEBPACK FOOTER //
// ./src/components/molecules/AppointmentFlowFooter/index.js